(function () {
  'use strict';

  // Free shipping bar is handled in catchy.js renderCart()
  // This file only hooks into cart open events for badge updates

  function hookIntoCart() {
    var _orig = window.CATCHY && window.CATCHY.renderCart;
    if (!_orig) return false;
    return true;
  }

  // Try immediately, then wait for catchy.js if needed
  if (!hookIntoCart()) {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (hookIntoCart() || attempts > 20) clearInterval(interval);
    }, 100);
  }

})();
